// @flow

import * as React from 'react';

import { useTranslator, mapTags } from '@gandi/translate';
import { Button, Base } from '@gandi/ui';

type Props = {
  fqdn: string,
};

export default function InfoContainer({ fqdn }: Props): React.Node {
  const { __ } = useTranslator();

  return (
    <Base marginBottom="base" className="wrapper-plain">
      <Base tagName="p">
        {mapTags(
          __(
            'In order to register %(fqdn)s, it is necessary to prove that you have the rights to the corresponding trademark.' +
              'You have to prove that you have the right to register example.com by uploading the SMD file linked to your trademark. [[link:Learn more]].',
            { fqdn },
          ),
          ({ link }) => ({
            link: (
              <a
                href={__(
                  'https://docs.gandi.net/en/domain_names/domain_services/tmch.html',
                )}
                target="_blank"
                rel="noopener noreferrer"
              >
                {link}
              </a>
            ),
          }),
        )}
      </Base>
      <Base flex flexAlignItemsCenter flexWrap>
        <Base tagName="p" margin="none" weight="semibold" marginRight="xsmall">
          {__(
            'You can ask Gandi to register your trademark with TMCH to get this.',
          )}
        </Base>
        <Button href="/" iconAfter="arrowRight" kind="ghost" small>
          {__('Request registration')}
        </Button>
      </Base>
    </Base>
  );
}
